import React, { useEffect, useState } from "react";
import { candidatesApi } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function Candidates() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { candidatesApi.list().then(setRows); }, []);
  const filtered = rows.filter((c) =>
    !q || c.name.toLowerCase().includes(q.toLowerCase()) || c.title.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground mb-1">Talent Graph</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Candidates</h1>
      </div>
      <div className="relative max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search candidates…" className="pl-9" />
      </div>
      <Card className="border-border shadow-none overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Candidate</TableHead>
              <TableHead>Title</TableHead>
              <TableHead>Location</TableHead>
              <TableHead className="text-right">Experience</TableHead>
              <TableHead>Skills</TableHead>
              <TableHead>Source</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filtered.map((c) => (
              <TableRow key={c.id} className="hover:bg-[#FAFAFA]">
                <TableCell>
                  <div className="flex items-center gap-2">
                    {c.avatar ? <img src={c.avatar} className="h-7 w-7 rounded-full object-cover" alt="" /> :
                      <div className="h-7 w-7 rounded-full bg-[#F4F4F5] grid place-items-center text-xs font-bold">{c.name[0]}</div>}
                    <div>
                      <div className="font-medium text-sm">{c.name}</div>
                      <div className="text-xs text-muted-foreground">{c.email}</div>
                    </div>
                  </div>
                </TableCell>
                <TableCell className="text-sm">{c.title}</TableCell>
                <TableCell className="text-sm">{c.location}</TableCell>
                <TableCell className="text-right font-mono text-sm">{c.experience_years}y</TableCell>
                <TableCell>
                  <div className="flex flex-wrap gap-1">
                    {c.skills.slice(0, 3).map((s) => <Badge key={s} variant="secondary" className="text-[10px] font-mono">{s}</Badge>)}
                  </div>
                </TableCell>
                <TableCell><Badge variant="outline" className="text-[10px] font-mono uppercase tracking-wider">{c.source}</Badge></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
